import { Component, ViewChild } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { DialogService } from 'src/app/core/dialog.service';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { COLOR_PRIMARY_CONTRAST_500, LOCAL_NAVBAR_STATUS_KEY } from 'src/app/shared/constants/operationals';
import { PendingInvitationsDataComponent } from '../pending-invitations-data/pending-invitations-data.component';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { ListStoresParams } from 'src/app/core/stores.service';
import { ListPendingInvitationsParams } from 'src/app/core/seller-invitations.service';
import { PendingInvitationsFilterDialogComponent } from '../pending-invitations-filter-dialog/pending-invitations-filter-dialog.component';

@Component({
  selector: 'app-pending-invitations',
  templateUrl: './pending-invitations.component.html',
  styleUrls: ['./pending-invitations.component.scss']
})
export class PendingInvitationsComponent {

    @ViewChild(PendingInvitationsDataComponent) data_component?: PendingInvitationsDataComponent;
    navbar_status: NavbarStatus;
    current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(NavigationItemLabel.pending_invitations);
    filters?: ListPendingInvitationsParams;
  
    constructor(
      private utils_service: UtilsService,
      private navigation_service: NavigationService,
      private dialog_service: DialogService,
      private meta: Meta,
    ) {
      this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
    }
  
    ngOnInit(): void {
      this.meta.updateTag({ content: COLOR_PRIMARY_CONTRAST_500 }, 'name=theme-color');
    }
  
    onRefresh(): void {
      this.onFilterClear({});
      //this.data_component?.onRefresh();
    }
  
    onFilter(): void {
      this.dialog_service
        .openDialog(PendingInvitationsFilterDialogComponent)
        ?.afterClosed()
        .subscribe(dialog_result => {
          if (dialog_result && dialog_result.params) {
            this.filters = dialog_result.params;
            this.setDataFilters();
          }
        });
    }
  
    onNavbarStatusChange(navbar_status: NavbarStatus): void {
      this.navbar_status = navbar_status;
      localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
    }
  
    onFilterClear(filters: ListStoresParams): void {
      this.filters = filters;
      this.setDataFilters();
    }
  
    setDataFilters(): void {
      if (this.areFiltersSet()) {
        this.data_component?.onFilter(this.filters);
      }
  
      if (!this.areFiltersSet()) {
        this.data_component?.onFilter();
      }
    }
  
    getNavbarClass(): { [key: string]: boolean | undefined } {
      return this.utils_service.getNavbarClass(this.navbar_status);
    }
  
    getToolbarWidthClass(): string {
      if (this.navbar_status == NavbarStatus.open) {
        return 'sp-toolbar__open-width';
      }
      return 'sp-toolbar__closed-width';
    }
  
    areFiltersSet(): boolean {
      if (!this.filters) return false;
  
      const active_filters = Object.keys(this.filters).filter(k => {
        if (!this.filters) return false;
        return this.filters[k as keyof typeof this.filters] != null;
      });
  
      return active_filters && active_filters.length ? true : false;
    }

}
